import React from 'react';
import { FiZap, FiLayers, FiUsers } from 'react-icons/fi';
import Reveal from './Reveal';
import Footer from './Footer';

const values = [
  {
    icon: FiZap,
    title: 'Innovation',
    desc: 'We stay close to what is new so your product does not age the day it launches.',
  },
  {
    icon: FiLayers,
    title: 'Craft',
    desc: 'Details matter. Clean code, considered design and interfaces that feel effortless.',
  },
  {
    icon: FiUsers,
    title: 'Partnership',
    desc: 'We work as an extension of your team, aligned to your goals — not just a brief.',
  },
];

const About = () => {
  return (
    <div>
      {/* Intro */}
      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0 bg-radial-mint" />
        <div className="container-x relative grid items-center gap-12 pt-36 pb-12 lg:grid-cols-2 lg:pt-44">
          <Reveal>
            <span className="section-kicker">About us</span>
            <h1 className="mt-4 font-display text-4xl font-bold leading-[1.1] text-ink sm:text-5xl">
              We craft experiences that help businesses{' '}
              <span className="text-gradient">thrive</span>
            </h1>
            <p className="mt-6 text-base leading-relaxed text-muted">
              We don't just build digital solutions — we craft experiences that
              empower businesses to grow in a fast-moving digital world.
              Specialising in custom software, web and app development, UI/UX
              design, marketing, SEO and AI-driven solutions, we're your hub for
              scaling a digital presence. We combine creative design, technical
              expertise and data-driven insight to deliver work that looks good
              and performs.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="hero-halo" />
              <img
                src="/rb_2148303918.png"
                loading="lazy"
                alt="Lotez team illustration"
                className="relative w-full drop-shadow-2xl"
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* Who we are */}
      <section className="section">
        <div className="container-x grid items-center gap-12 lg:grid-cols-2">
          <Reveal className="order-2 flex justify-center lg:order-1">
            <img
              src="/rb_717.png"
              loading="lazy"
              alt="Building digital solutions"
              className="w-full max-w-sm drop-shadow-2xl"
            />
          </Reveal>
          <Reveal delay={0.1} className="order-1 lg:order-2">
            <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl">
              Who <span className="text-gradient">we are</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted">
              We're dedicated to turning ideas into robust digital solutions.
              Our team leverages modern technologies to deliver high-quality
              software tailored to each client's needs. From early-stage
              startups to established enterprises, we help businesses compete by
              shipping scalable, efficient and genuinely user-friendly products.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Values */}
      <section className="section">
        <div className="container-x">
          <Reveal className="mx-auto max-w-2xl text-center">
            <span className="section-kicker">What guides us</span>
            <h2 className="mt-3 font-display text-3xl font-bold text-ink sm:text-4xl">
              Principles behind the <span className="text-gradient">work</span>
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-5 md:grid-cols-3">
            {values.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.06}>
                <div className="glass-card h-full rounded-4xl p-8">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brandSoft text-brand">
                    <v.icon className="text-xl" />
                  </div>
                  <h3 className="mt-6 font-display text-lg font-semibold text-ink">
                    {v.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted">
                    {v.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Statement panel */}
      <section className="section">
        <div className="container-x">
          <Reveal>
            <div className="glass-card grid gap-10 rounded-3xl p-8 sm:p-12 lg:grid-cols-[.75fr_1.25fr] lg:p-16">
              <div>
                <p className="section-kicker">Lotez Technologies</p>
                <h2 className="mt-3 font-display text-3xl font-bold text-ink sm:text-4xl">
                  Technology with purpose.
                </h2>
              </div>
              <div>
                <p className="font-display text-xl font-medium leading-relaxed text-ink sm:text-2xl">
                  Modern aesthetics and user-centred design come together with
                  robust engineering to make digital products useful, memorable
                  and ready to grow.
                </p>
                <p className="mt-5 leading-relaxed text-muted">
                  From Hyderabad, we help businesses transform operations into
                  focused digital solutions — with one team spanning strategy,
                  design, development, growth and telecom integration.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
